
import store from '@/store';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LogoutBtn extends Vue {
  @Prop({
    default: false,
  })
  private miniVariant!: boolean;

  private dialog = false;

  private onOpenConfirmDialog(): void {
    this.dialog = true;
  }

  private async onLogout(): Promise<void> {
    await store.dispatch('moduleAuthData/logOutUser');
    await this.$router.push('/login');
    this.dialog = false;
  }
}
